/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPlusColumnTop: {
  name: 'plus-column-top';
  data: string;
} = {
  name: 'plus-column-top',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4a2 2 0 0 1 2-2h5c.147 0 .286.032.411.088A2 2 0 0 1 10 2h4c.205 0 .403.03.589.088A.997.997 0 0 1 15 2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2H4a2 2 0 0 1-2-2V4Zm8 7v1h4V4h-4v7Zm6-1h4V4h-4v6Zm-8 0H4V4h4v6Zm4 6a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
